import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface FacetPriceContainerProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element | JSX.Element[]
}

const FacetPriceContainer = memo(({children, templating}: FacetPriceContainerProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName>{children}</ComponentName>
})
FacetPriceContainer.displayName = "FacetPriceContainer"
export default connect(FacetPriceContainer)
